<template>
    <div class="kgr-inputGroup kgr-inputGroup--constrainedWidth">
        <kgr-form-row
            :label="$t('Übergeordnete Abteilung')"
            :error="error"
            field-name="parentDepartment"
        >
            <kgr-department-select
                hide-label
                :value="parentDepartment"
                :club-id="clubId"
                :default-text="defaultSelectText"
                @post-input="onDepartmentSelected"
                @optionsLoaded="departmentOptions = $event"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('department.name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="department.name"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('department.shortName')"
            :error="error"
            field-name="shortName"
        >
            <input
                v-model.trim="department.shortName"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('department.dateOfFounding')"
            :error="error"
            field-name="dateOfFounding"
            :tooltip="$t('Format: TT.MM.JJJJ')"
        >
            <kgr-date-picker
                v-model.trim="department.dateOfFounding"
                @enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import DatePicker from '../common/form/picker/DatePicker';
import Department from '../../js/dto/Department';
import DepartmentSelect from '../common/form/select/DepartmentSelect';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    name: 'KgrDepartmentCreateForm',
    components: {
        'kgr-department-select': DepartmentSelect,
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        department: {
            type: Department,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            departmentOptions: [],
        };
    },
    computed: {
        defaultSelectText() {
            return `- ${this.$t('Keine')} -`;
        },
        queryParentDepartmentId() {
            const id = (new URL(document.location)).searchParams.get('parentDepartment');

            return id === null ? null : Number(id);
        },
        parentDepartment() {
            return this.departmentOptions.find((department) => this.department.parentDepartmentId && this.department.parentDepartmentId === department.id);
        },
    },
    created() {
        if (this.queryParentDepartmentId) {
            return this.department.parentDepartmentId = this.queryParentDepartmentId;
        }
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
        onDepartmentSelected(department) {
            this.department.parentDepartmentId = department.id;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
